import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import DocumentTitle from 'react-document-title';
import OutsideClickHandler from 'react-outside-click-handler';
import React, { useEffect, useState } from 'react';
import Div100vh from 'react-div-100vh';
import { fetchAuthenticatedUser } from 'src/store/actions/auth';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import Button from '../../components/Button';
import FontAwesomeIcon from '../../components/Icon';
import Loader from '../../components/Loader';
import { setSideBar } from 'src/store/actions/collapseSideBar';
import { selectCollapseSideBar } from 'src/store/selectors/collapseSideBar';
import ModernSidebar from 'src/layouts/WithNavigation/ModernSidebar/ModernSidebar';
import { Images } from 'src/Tenants';
import './WithNavigation.scss';
import { useBranding } from 'src/branding/BrandingContextProvider';

interface WithNavigationProps {
  bottom?: any;
  title?: any;
  top?: any;
  border?: any;
  hide?: any;
  children?: any;
  id?: any;
  testId?: any;
}

const WithNavigation = ({
  bottom,
  title,
  top,
  border,
  hide,
  children,
  id,
  testId,
}: WithNavigationProps) => {
  const [sidebarIsVisible, setSidebarIsVisible] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector(selectAuthenticatedUser);
  const collapsableSideBar = useSelector(selectCollapseSideBar);

  useEffect(() => {
    dispatch(fetchAuthenticatedUser() as any);
  }, []);

  const collapsableSideBarHandler = () => {
    dispatch(setSideBar(!collapsableSideBar) as any);
  };

  const theme = localStorage.getItem('theme');
  const {branding} = useBranding();
  const content = children ?? bottom;

  return user ? (
    <DocumentTitle
      title={`${title} | ${branding.text.applicationName || 'juniper'}`}
    >
      <>
        <Div100vh className="with-navigation">
          <OutsideClickHandler
            onOutsideClick={() => {
              setSidebarIsVisible(false);
            }}
          >
            <div
              className={classNames('nav-sidebar', {
                'is-visible': sidebarIsVisible,
                'is-collapsed': collapsableSideBar,
              })}
            >
              <ModernSidebar
                collapsableSideBar={() => collapsableSideBarHandler()}
                collapseSideBar={collapsableSideBar}
              />
            </div>
          </OutsideClickHandler>
          <div
            className={classNames('nav-scrim', {
              'is-visible': sidebarIsVisible,
            })}
          />
          <div
            className={classNames('nav-main', {
              'is-collapsed': collapsableSideBar,
            })}
          >
            <div className="nav-topbar">
              <div className="nav-menu-toggle">
                <Button
                  onClick={() => setSidebarIsVisible(!sidebarIsVisible)}
                  weight="semantic"
                  icon={<FontAwesomeIcon weight="light" glyph="bars" />}
                />
              </div>
              <div className="nav-logo">
                <img
                  alt="juniper"
                  src={Images.logo}
                  style={{
                    height:
                      theme === 'Formwerks'
                        ? 'auto'
                        : theme === 'Quadra' || theme === 'Panatch'
                          ? '4rem'
                          : '2.5rem',
                  }}
                />
              </div>
            </div>
            <div className="nav-scroll" data-cy={testId} id={id}>
              {top && (
                <div
                  className="nav-header"
                  style={{ borderBottomWidth: border ? 0 : null }}
                >
                  {top}
                </div>
              )}
              <div
                className="nav-body"
                style={{ display: hide === true && 'none' }}
              >
                <div className="nav-content">{content}</div>
              </div>
            </div>
          </div>
        </Div100vh>
      </>
    </DocumentTitle>
  ) : (
    <Loader />
  );
};

export default WithNavigation;
